<!-- ================= HERO ================= -->
<div class="hero section-onepage" id="hero">
  <!-- Photo de Sousse en fond plein ecran, alterne avec le globe -->
  <div class="hero-photo-fond" [class.visible]="photoVisible">
    <img [src]="parametres?.photoHero || 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=1600'" alt="Vue de Sousse">
    <div class="hero-photo-voile"></div>
  </div>

  <div class="hero-globe" [class.estompe]="photoVisible">
    <canvas #canvasGlobe></canvas>
  </div>
  <div class="hero-texte">
    <span class="eyebrow" *ngIf="parametres">{{ parametres.edition }} — {{ parametres.dates }}</span>
    <h1>{{ parametres?.nomFestival || 'Festival International de Sousse' }}</h1>
    <p>{{ parametres?.adresse }} — {{ 'hero.souscite' | traduire }}</p>

    <p class="note-info" *ngIf="parametres?.noteInfo">
      <span class="note-info-point"></span>{{ parametres?.noteInfo }}
    </p>

    <a routerLink="/" fragment="programme" class="btn-gold">{{ 'hero.cta' | traduire }}</a>

    <div class="compte-a-rebours" *ngIf="!festivalDejaOuvert">
      <div class="cr-bloc"><span class="cr-nombre">{{ joursAvantOuverture }}</span><span class="cr-label">{{ 'cd.jours' | traduire }}</span></div>
      <div class="cr-sep"></div>
      <div class="cr-bloc"><span class="cr-nombre">{{ heuresAvantOuverture }}</span><span class="cr-label">{{ 'cd.heures' | traduire }}</span></div>
      <div class="cr-sep"></div>
      <div class="cr-bloc"><span class="cr-nombre">{{ minutesAvantOuverture }}</span><span class="cr-label">{{ 'cd.minutes' | traduire }}</span></div>
      <div class="cr-sep"></div>
      <div class="cr-bloc"><span class="cr-nombre">{{ secondesAvantOuverture }}</span><span class="cr-label">{{ 'cd.secondes' | traduire }}</span></div>
    </div>
  </div>
</div>

<!-- Bandeau de points forts, pour donner du contenu au scroll -->
<div class="points-forts">
  <div class="point"><span class="icone">☀️</span><div><b>{{ 'hi.sun.t' | traduire }}</b><span>{{ 'hi.sun.s' | traduire }}</span></div></div>
  <div class="point"><span class="icone">🏛️</span><div><b>{{ 'hi.unesco.t' | traduire }}</b><span>{{ 'hi.unesco.s' | traduire }}</span></div></div>
  <div class="point"><span class="icone">🎭</span><div><b>{{ 'hi.edition.t' | traduire }}</b><span>{{ 'hi.edition.s' | traduire }}</span></div></div>
  <div class="point"><span class="icone">✈️</span><div><b>{{ 'hi.aero.t' | traduire }}</b><span>{{ 'hi.aero.s' | traduire }}</span></div></div>
</div>

<!-- ================= ABOUT : "L'ame du festival" ================= -->
<div class="container about-section section-onepage" id="about">
  <div class="about-photo">
    <img [src]="parametres?.photoAme || 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=700'" alt="Ambiance concert">
  </div>
  <div class="about-texte">
    <span class="eyebrow">{{ 'about.eyebrow' | traduire }}</span>
    <h2>{{ 'about.titre' | traduire }}</h2>
    <p>{{ 'about.texte' | traduire }}</p>

    <div class="stats-anneaux">
      <div class="stat">
        <div class="chiffre">{{ statNuits }}</div>
        <div class="label">{{ 'about.nuits' | traduire }}</div>
      </div>
      <div class="stat">
        <div class="chiffre">{{ statArtistes }}+</div>
        <div class="label">{{ 'about.artistes' | traduire }}</div>
      </div>
      <div class="stat">
        <div class="chiffre">{{ statSpectateurs }}K</div>
        <div class="label">{{ 'about.spectateurs' | traduire }}</div>
      </div>
    </div>
  </div>
</div>

<!-- "Vivre a Sousse" : citation immersive -->
<div class="quote-section">
  <div class="quote-fond"></div>
  <div class="quote-contenu">
    <span class="eyebrow">{{ 'quote.eyebrow' | traduire }}</span>
    <p class="quote-texte">{{ 'quote.texte' | traduire }}</p>
    <span class="quote-auteur">{{ 'quote.auteur' | traduire }}</span>
  </div>
</div>

<!-- ================= THEATRE ================= -->
<section class="section-onepage section-separee" id="theatre">
  <app-theatre></app-theatre>
</section>

<!-- ================= PROGRAMME ================= -->
<section class="section-onepage section-separee" id="programme">
  <app-programme></app-programme>
</section>

<!-- ================= ARTISTES ================= -->
<section class="section-onepage section-separee" id="artistes">
  <app-artistes></app-artistes>
</section>

<!-- ================= ARCHIVES ================= -->
<section class="section-onepage section-separee" id="archives">
  <app-archives></app-archives>
</section>

<!-- ================= DECOUVRIR SOUSSE ================= -->
<section class="section-onepage section-separee" id="decouvrir">
  <app-decouvrir></app-decouvrir>
</section>

<!-- ================= TEMOIGNAGES ================= -->
<div class="container section-onepage" id="temoignages">
  <span class="eyebrow">{{ 'temoi.eyebrow' | traduire }}</span>
  <h2>{{ 'temoi.titre' | traduire }}</h2>

  <div class="temoi-grid" *ngIf="temoignages.length > 0">
    <div class="temoi-carte" *ngFor="let t of temoignages">
      <div class="etoiles">{{ '★'.repeat(t.note) }}{{ '☆'.repeat(5 - t.note) }}</div>
      <p>« {{ t.contenu }} »</p>
      <span class="auteur">{{ t.auteur }} — {{ t.lieu }}</span>
    </div>
  </div>
  <p class="temoi-vide" *ngIf="temoignages.length === 0">{{ 'temoi.vide' | traduire }}</p>

  <div class="temoi-form-bloc">
    <h3 class="temoi-form-titre">{{ 'temoi.partager' | traduire }}</h3>

    <form class="temoi-form" (ngSubmit)="envoyerTemoignage()" *ngIf="!temoignageEnvoye">
      <div class="temoi-etoiles-choix">
        <span *ngFor="let n of [1,2,3,4,5]"
              [class.pleine]="n <= formTemoignage.note"
              (click)="formTemoignage.note = n">★</span>
      </div>

      <div class="avis-ligne">
        <input type="text" [(ngModel)]="formTemoignage.auteur" name="auteurTemoi" [placeholder]="'avis.nom' | traduire" required>
        <input type="text" [(ngModel)]="formTemoignage.lieu" name="lieuTemoi" placeholder="Ville / pays" required>
      </div>
      <textarea [(ngModel)]="formTemoignage.contenu" name="contenuTemoi" rows="3"
                [placeholder]="'temoi.placeholder' | traduire" required></textarea>

      <button type="submit" class="btn-gold" [disabled]="envoiTemoignageEnCours">{{ 'temoi.envoyer' | traduire }}</button>
    </form>

    <p class="avis-merci" *ngIf="temoignageEnvoye">✓ {{ 'temoi.merci' | traduire }}</p>
  </div>
</div>

<!-- ================= AVIS & RECLAMATIONS ================= -->
<div class="container avis-section section-onepage" id="avis">
  <span class="eyebrow">{{ 'avis.eyebrow' | traduire }}</span>
  <h2>{{ 'avis.titre' | traduire }}</h2>
  <p class="avis-intro">{{ 'avis.texte' | traduire }}</p>

  <form class="avis-form" (ngSubmit)="envoyerAvis()" *ngIf="!avisEnvoye">
    <div class="avis-type">
      <button type="button" [class.actif]="formAvis.type === 'avis'" (click)="formAvis.type = 'avis'">
        💬 {{ 'avis.type.avis' | traduire }}
      </button>
      <button type="button" [class.actif]="formAvis.type === 'reclamation'" (click)="formAvis.type = 'reclamation'">
        ⚠ {{ 'avis.type.reclamation' | traduire }}
      </button>
    </div>

    <div class="avis-ligne">
      <input type="text" [(ngModel)]="formAvis.nom" name="nom" [placeholder]="'avis.nom' | traduire" required>
      <input type="email" [(ngModel)]="formAvis.email" name="email" [placeholder]="'avis.email' | traduire" required>
    </div>
    <input type="text" [(ngModel)]="formAvis.sujet" name="sujet" [placeholder]="'avis.sujet' | traduire" required>
    <textarea [(ngModel)]="formAvis.message" name="message" rows="4" [placeholder]="'avis.message' | traduire" required></textarea>

    <button type="submit" class="btn-gold" [disabled]="envoiEnCours">{{ 'avis.envoyer' | traduire }}</button>
  </form>

  <p class="avis-merci" *ngIf="avisEnvoye">✓ {{ 'avis.merci' | traduire }}</p>
</div>

<!-- Bandeau d'appel a l'action final -->
<div class="cta-final">
  <h2>{{ 'cta.titre' | traduire }}</h2>
  <p>{{ 'cta.texte' | traduire }}</p>
  <div class="cta-boutons">
    <a routerLink="/" fragment="programme" class="btn-gold">{{ 'hero.cta' | traduire }}</a>
    <a routerLink="/" fragment="decouvrir" class="btn-outline">{{ 'cta.decouvrir' | traduire }}</a>
  </div>
</div>

<!-- ================= CONTACT (tout en bas de page) ================= -->
<section class="section-onepage section-separee" id="contact">
  <app-contact></app-contact>
</section>
